import { atom } from "jotai";

/**
 * Fakes hitting the time limit for live TV.
 * This should not be used in production.
 */
export const forceLiveTvTimeLimitReachedAtom = atom<boolean>(false);
